import {
  DEFAULT_ITEMS_LIMIT,
  MAX_ITEMS_LIMIT,
  MIN_ITEMS_LIMIT,
} from 'govbr.frontend.policy/components/Blocks/PublicConsultationsListing/schema';

import { GET_PUBLIC_CONSULTATIONS } from '../../constants/ActionTypes';

const normalizeLimit = (value) => {
  const parsedValue = Number.parseInt(value, 10);
  if (Number.isNaN(parsedValue)) {
    return DEFAULT_ITEMS_LIMIT;
  }
  return Math.min(MAX_ITEMS_LIMIT, Math.max(MIN_ITEMS_LIMIT, parsedValue));
};

const normalizeFiltroOrgao = (value) => {
  if (typeof value === 'boolean') {
    return value ? 'yes' : 'no';
  }

  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  return ['1', 'true', 'yes', 'on'].includes(normalized) ? 'yes' : 'no';
};

/**
 * Fetches the public consultations listing from backend.
 */
export function getPublicConsultations({
  path = '/@public-consultations',
  params = {},
} = {}) {
  const requestParams = {
    limit: normalizeLimit(params?.limit),
    filtro_orgao: normalizeFiltroOrgao(params?.filtro_orgao),
  };

  return {
    type: GET_PUBLIC_CONSULTATIONS,
    request: {
      op: 'get',
      path,
      params: requestParams,
    },
  };
}
